import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/visuado-logo-vertical.png")